import { getApiClient, initializeApiClient } from "../../../apiService";

export const UpdateJordanianGovernoratesProjectActivities = async (
  tG_JordanianGovernoratesProjectActivitiesId,
  tG_JordanianGovernoratesNameId,
  tG_MainTargetedGroupId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TG_JordanianGovernoratesProjectActivities/UpdateTG_JordanianGovernoratesProjectActivities`,
    {
      tG_JordanianGovernoratesProjectActivitiesId:
        tG_JordanianGovernoratesProjectActivitiesId,
      tG_JordanianGovernoratesNameId: tG_JordanianGovernoratesNameId,
      tG_MainTargetedGroupId: tG_MainTargetedGroupId,
    }
  );

  return response;
};

export default UpdateJordanianGovernoratesProjectActivities;
